module.exports = __webpack_public_path__ + "static/media/7.98be157f.jpeg";